import { ComponentProps, createElement, ElementType, forwardRef } from 'react'

type JSXComponent = ElementType

export interface ComponentMapper<T extends JSXComponent> {
  (target: T): JSXComponent
}

export const mapReadonlyComponent =
  <C extends JSXComponent, T extends JSXComponent>(component: C) =>
  (target: T) =>
    forwardRef(({ readonly, ...props }: ComponentProps<T> & { readonly?: boolean }, ref) =>
      createElement(readonly ? component : target, { ...props, ref })
    )

export const connect = <T extends JSXComponent>(target: T, ...args: ComponentMapper<T>[]) => {
  const Target = args.reduce<T>((acc, mapper) => {
    acc = mapper(target) as T
    return acc
  }, target)

  return forwardRef((props: ComponentProps<T>, ref) => createElement(Target, { ...props, ref }))
}

export const connectReadonlyComponent = <T extends JSXComponent, P extends JSXComponent>(
  target: T,
  preview: P
) => connect(target, mapReadonlyComponent(preview))

export default connect
